import { render } from "./gmTransferGameDesc.vue?vue&type=template&id=1422a284&scoped=true"
const script = {}

import "./gmTransferGameDesc.vue?vue&type=style&index=0&id=1422a284&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1422a284"]])

export default __exports__